/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlaceWorkingHourDto } from './placeWorkingHourDto';
import { HappyHourDto } from './happyHourDto';
import { PlaceInformationLinkDto } from './placeInformationLinkDto';


export interface PublicPlaceInformationDto { 
    id?: number;
    logo?: string;
    placeWorkingHours?: Array<PlaceWorkingHourDto>;
    links?: Array<PlaceInformationLinkDto>;
    happyHours?: Array<HappyHourDto>;
}

